<template>
  <div>
    <div class="weixin-tip">
      <p>
        <img src="/static/img/live_weixin.png" alt="微信打开"/>
      </p>
	</div>

  <div class="show" v-if="showInfo">
    
    <div class="box">
      <div class="logo" @click="goHome">
        <h1>北京佰标</h1>
      </div>
      <div class="certificate">
        <div class="title">
          <h2 class="">参编人员查询结果</h2>
          <a class="down" @click="download()">电子证书下载</a>
          <router-link class="inquery" :to="$QueryPath">继续查询</router-link>
        </div>
        <div class="baseinfo">
          <ul>
            <li class="title">人员基本信息</li>
            <li>
              <span class="cname">姓 名</span>
              <span class="info line">{{ showInfo.name }}</span>
              <span class="cname">性 别</span>
              <span class="info">{{ showInfo.sex }}</span>
            </li>
            <li>
              <span class="cname">出生日期</span>
              <span class="info line">{{ showInfo.birthday }}</span>
              <span class="cname">身份证号</span>
              <span class="info">{{ showInfo.cardid }}</span>
            </li>
            <li>
              <span class="cname">民 族</span>
              <span class="info line">{{ showInfo.nation }}</span>
              <span class="cname">籍 贯</span>
              <span class="info">{{ showInfo.origin }}</span>
            </li>
            <li>
              <span class="cname">职业资格</span>
              <span class="info line">{{ showInfo.vocational }}</span>
              <span class="cname">职业等级</span>
              <span class="info">{{ showInfo.vocationallevel }}</span>
            </li>
            <li>
              <span class="cname">资格名称</span>
              <span class="info line">{{ showInfo.qualification }}</span>
              <span class="cname">资格类别</span>
              <span class="info">{{ showInfo.qualificationtype }}</span>
            </li>
            <li class="bottom">
              <span class="cname">现任职单位</span>
              <span class="info">{{ showInfo.danwei }}</span>
            </li>
          </ul>
        </div>
        <div class="cateinfo">
          <ul v-if="showInfo.code">
            <li class="title">证书基本信息</li>
            <li>
              <span class="cname">证书名称</span>
              <span class="info">{{ showInfo.certname.replace(/\//g,'') }}</span>
            </li>
            <li>
              <span class="cname">证书类型</span>
              <span class="info">{{ showInfo.certtype }}</span>
            </li>
            <li>
              <span class="cname">证书编号</span>
              <span class="info">{{ showInfo.code }}</span>
            </li>
            <li>
              <span class="cname">证书标准号</span>
              <span class="info">{{ showInfo.certcode }}</span>
            </li>
            <li>
              <span class="cname">证书颁发机构</span>
              <span class="info">{{ showInfo.regauth }}</span>
            </li>
            <li>
              <span class="cname">发证机构网址</span>
              <span class="info">{{ showInfo.regurl | upperFilter }}</span>
            </li>
            <li class="big">
              <span class="cnameb">技术支持单位</span>
              <div class="col">
                <div class="one">
                  <span class="inline">{{ showInfo.jszcdw[0].name }}</span>
                  <span>{{showInfo.jszcdw[0].path}}</span>
                </div>
                <div class="one">
                  <span class="inline">{{ showInfo.jszcdw[1].name }}</span>
                  <span>{{showInfo.jszcdw[1].path}}</span>
                </div>
                <div class="one">
                  <span class="inline">{{ showInfo.jszcdw[2].name }}</span>
                  <span>{{showInfo.jszcdw[2].path}}</span>
                </div>
                <div class="two">
                  <span class="inline">{{ showInfo.jszcdw[3].name }}</span>
                  <span>{{showInfo.jszcdw[3].path}}</span>
                </div>
              </div>
            </li>
            <li class="bottom">
              <span class="info">证书年检记录</span>
              <span :class="index == 2 ? 'ends' :'info'" v-for="(item,index) in showInfo.nianjian" :key="index">
                <img v-if="item" :src="`${IP_TEST}/uploads/${sealpicsrc}`" width="142" />
                <span>{{item}}</span>
              </span>
            </li>
          </ul>
          <ul v-else>
            <li class="title">证书基本信息</li>
            <li class="overdue">
              已过期
            </li>
          </ul>
        </div>
      </div>
      <div class="copyright">©CopyRight 2023-2024 版权所有</div>
    </div>
  </div>
</div>
</template>

<script>
/**
 * 主编人员查询系统模版
 */
import { IP_TEST } from '@/config';
export default {
  name: "ShowCbry",
  data() {
    return {
      IP_TEST
    }
  },
  computed: {
    sealpicsrc() {
      return localStorage.getItem('sealpicsrc');
    }
  },
  props: {
    showInfo: Object
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    download() {
      // if(this.isWeixinBrowser())
      // {
      //   var winHeight = $(window).height();
      //   $(".weixin-tip").css("height",winHeight);
      //   $(".weixin-tip").show();
      //   return;
      // }
      // window.open(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code}_${this.showInfo.socialcreditcode}.jpg`, "_blank");
      // return;
      this.$axios
        .get(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.cardid}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.cardid}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.cardid}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${IP_TEST}/bzw/loadimgs?imgpath=证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.cardid}.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width: 100%;
  height: 1522px;
  background: url(/static/img/inq/chaxun_bg2.png) no-repeat;
  background-size: auto;
}
.show>.box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  padding: 18px;
}
.box>.logo {
  position: relative;
  height: 104px;
  background: url(/static/img/inq/logo1.png) no-repeat;
  background-size: 511px 104px;
  overflow: hidden;
}

.box>.logo>h1 {
  position: absolute;
  left: -1116px;
}
.box>.certificate{
  position: relative;
  margin-top: 51px;
  width: 1200px;
  /* height: 1265px; */
  background: #FFFFFF;
  box-shadow: -1px 4px 18px 0px rgba(0, 170, 185, 0.41);
  overflow: hidden;
}
.box>.certificate>.title{
  margin: 38px 0 42px;
  height: 61px;
  display: flex;
  justify-content: end;
}
.box>.certificate>.title>h2{
  width: 532px;
  height: 61px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 61px;
  background: url(/static/img/inq/biaoti_kug.png) no-repeat;
  background-size: 532px 61px;
}
.box>.certificate>.title>a.down{
  margin-left:89px;
  margin-right:46px;
  width: 102px;
  height: 61px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #5A94F1;
  line-height: 61px;
  text-align: center;
}
.box>.certificate>.title>a.inquery {
  margin-right: 27px;
  width: 68px;
  height: 61px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 61px;
  text-align: center;
}
.box>.certificate>.baseinfo>ul{
  margin-left: 30px;
  width: 1145px;
  height: 369px;
}
.cateinfo>ul{
  margin-top: 24px;
  margin-left: 30px;
  width: 1145px;
  height: 696px;
  background: url(/static/img/inq/hua_icon.png) no-repeat;
  background-size: 606px 545px;
  background-position:281px 87px;
}
.box>.certificate>.baseinfo>ul>li,.cateinfo>ul>li{
  width: 1141px;
  height: 50px;
  border-bottom:1px solid #F0F0F0;
  border-left:1px solid #D1D1D1;
  border-right:1px solid #D1D1D1;
  display: flex;
  justify-content: start;
}
.box>.certificate>.baseinfo>ul>li>span.cname,.cateinfo>ul>li>span.cname{
  display: inline-block;
  width: 123px;
  height: 50px;
  border-right: 1px solid #F0F0F0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 50px;
  padding-left: 56px;
}
.cateinfo>ul>li.big{
  position: relative;
  display: flex;
  justify-content: start;
  min-height: 160px;
  overflow: hidden;
}
.cateinfo>ul>li.big>.col{
  position: relative;
  overflow: hidden;
  width: 961px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 40px;
}
.cateinfo>ul>li.big>.col>.one,.cateinfo>ul>li.big>.col>.two{
  width: 961px;
  height: 40px;
}
.cateinfo>ul>li.big>.col>.one{
  border-bottom: 1px solid #F0F0F0;
}
.cateinfo>ul>li.big>.col>.one>span,.cateinfo>ul>li.big>.col>.two>span{
  display: inline-block;
  padding-left: 57px;
  width: 180px;
}
.cateinfo>ul>li.big>.col>.one>span.inline,
.cateinfo>ul>li.big>.col>.two>span.inline {
  border-right:1px solid #F0F0F0;
}
.cateinfo>ul>li.big>span.cnameb{
  width: 123px;
  height: 160px;
  border-right: 1px solid #F0F0F0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 160px;
  padding-left: 56px;
}
.box>.certificate>.baseinfo>ul>li>span.info,.cateinfo>ul>li>span.info{
  padding-left: 57px;
  display: inline-block;
  height: 50px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 50px;
}
.box>.certificate>.baseinfo>ul>li>span.line{
  width: 333px;
  border-right: 1px solid #F0F0F0;
}
.box>.certificate>.baseinfo>ul>li.bottom{
  border-bottom: 1px solid #D1D1D1;
  height: 53px;
  line-height: 53px;
}
.cateinfo>ul>li.bottom {
  border-bottom: 1px solid #D1D1D1;
  height: 95px;
  line-height: 95px;
  display: flex;
  justify-content: start;
}

.cateinfo>ul>li.bottom>span.info,.cateinfo>ul>li.bottom>span.ends {
  padding-left: 0;
  width: 284px;
  height: 95px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 95px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.cateinfo>ul>li.overdue{
    border-bottom: 1px solid #D1D1D1;
    height: 634px;
    line-height: 634px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cateinfo>ul>li.bottom>span.info>span,.cateinfo>ul>li.bottom>span.ends>span {
  height: 24px;
  line-height: 24px;
}
.cateinfo>ul>li.bottom>span.info{
  border-right:1px solid #F0F0F0;
}

.box>.certificate>.baseinfo>ul>li.title,.cateinfo>ul>li.title{
  width: 1123px;
  height: 62px;
  padding-right: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 62px;
  text-align: center;
  background: rgba(239, 244, 253, .1) url(/static/img/inq/icon_xiantiao.png) no-repeat;
  background-size: 1143px 62px;
  border: 0;
  justify-content: center;
}

.box>.copyright{
  position: relative;
  margin-top: 35px;
  margin-left: 501px;
  width: 219px;
  height: 13px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #303030;
  line-height: 13px;
}
</style>